var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 217,
    fill: "#EEECF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_3250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.955 152.703C157.617 153.288 157.132 153.773 156.547 154.11C155.963 154.448 155.3 154.625 154.625 154.625H62.375C61.7006 154.624 61.0382 154.446 60.4545 154.109C59.8707 153.771 59.386 153.286 59.0491 152.701C58.7122 152.117 58.535 151.455 58.5352 150.78C58.5353 150.106 58.7129 149.443 59.0501 148.859C66.3677 136.209 77.6443 127.137 90.8043 122.837C84.2948 118.962 79.2372 113.057 76.4084 106.029C73.5796 99.0017 73.136 91.2397 75.1455 83.9354C77.1551 76.6311 81.5068 70.1884 87.5324 65.5967C93.558 61.005 100.924 58.5182 108.5 58.5182C116.076 58.5182 123.442 61.005 129.468 65.5967C135.493 70.1884 139.845 76.6311 141.854 83.9354C143.864 91.2397 143.42 99.0017 140.591 106.029C137.763 113.057 132.705 118.962 126.196 122.837C139.356 127.137 150.632 136.209 157.95 148.859C158.288 149.443 158.466 150.106 158.467 150.781C158.468 151.455 158.291 152.118 157.955 152.703Z",
    fill: "#98989D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_3250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white",
    transform: "translate(47 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.34bc4581a201cf47a695732646541fe6.svg";
export { ForwardRef as ReactComponent };